import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { Item } from '@radix-ui/react-accordion';

export type AccordionItemProps = ComponentPropsWithoutRef<typeof Item>;

const AccordionItem = forwardRef<ElementRef<typeof Item>, AccordionItemProps>(
  ({ className, ...props }, ref) => <Item ref={ref} className={className} {...props} />
);

AccordionItem.displayName = 'AccordionItem';

export default AccordionItem;
